import { PackDetails } from "modules/packs";

const PackInfoPage = () => <PackDetails />;

export default PackInfoPage;
